function pickRecorderMimeType() {
  if (typeof window.MediaRecorder === 'undefined' || !window.MediaRecorder.isTypeSupported) {
    return '';
  }
  const candidates = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/mp4',
    'audio/mp4;codecs=mp4a.40.2',
  ];
  return candidates.find((t) => window.MediaRecorder.isTypeSupported(t)) || '';
}

function browserSupportsDictation() {
  return !!(
    navigator.mediaDevices &&
    typeof navigator.mediaDevices.getUserMedia === 'function' &&
    typeof window.MediaRecorder === 'function'
  );
}

function insertAtCaret(field, text) {
  const el = field;
  const start = el.selectionStart ?? el.value.length;
  const end = el.selectionEnd ?? el.value.length;
  const v = el.value;
  el.value = `${v.slice(0, start)}${text}${v.slice(end)}`;
  const pos = start + text.length;
  el.selectionStart = pos;
  el.selectionEnd = pos;
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
}

function extensionForBlob(blob) {
  const t = (blob.type || '').toLowerCase();
  if (t.includes('mp4')) return 'mp4';
  if (t.includes('mpeg')) return 'mp3';
  if (t.includes('wav')) return 'wav';
  if (t.includes('ogg')) return 'ogg';
  return 'webm';
}

export { pickRecorderMimeType, browserSupportsDictation, insertAtCaret, extensionForBlob };
